import React from "react"
import { Select } from "antd"

export default function NewJob({ value, setValue }) {
  // Convert the parent boolean into a string for the Select
  const selectValue = value ? "Yes" : "No"

  // When user picks a new string, convert it back to boolean
  const handleChange = (newVal) => {
    setValue(newVal === "Yes")
  }

  // For user-facing labels and matching values
  const options = [
    { label: "No", value: "No" },
    { label: "Yes", value: "Yes" },
  ]

  return (
    <Select
      style={{ width: "100%" }}
      placeholder="New Job?"
      value={selectValue} // Shows "Yes" or "No"
      onChange={handleChange} // Convert back to boolean
      options={options} // Label & value pairs
      optionFilterProp="children"
    />
  )
}
